import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UpcomingComponent } from './modules/upcoming/upcoming.component';
import { ContactComponent } from './modules/contact/contact.component';
import { AboutComponent } from './modules/about/about.component';
import { NotFoundComponent } from './modules/not-found/not-found.component';
import { EventComponent } from './modules/event/event.component';
import { AgendaComponent } from './modules/event/agenda/agenda.component';
import { ExhibitionComponent } from './modules/event/exhibition/exhibition.component';
import { RegisterComponent } from './modules/event/register/register.component';
import { LoginComponent} from './modules/login/login.component';
import { RegisterSuccessComponent } from './modules/event/register-success/register-success.component';

import { SocietyComponent } from './modules/event/society/society.component';
import { SponsorsComponent } from './modules/event/sponsors/sponsors.component';
import { TopicsComponent } from './modules/event/topics/topics.component';
import { Speaker3Component } from './modules/event/speaker3/speaker3.component';
import { Speaker4Component } from './modules/event/speaker4/speaker4.component';
import { LiveComponent } from './modules/event/live/live.component';

import { ForgetPassComponent } from './modules/forget-pass/forget-pass.component';
import { CountdownnComponent } from './modules/event/countdownn/countdownn.component';
import { QuestionsComponent } from './modules/event/questions/questions.component';
import { FinishedComponent } from './modules/event/finished/finished.component';

import { Society2Component } from './modules/event/society2/society2.component';
import { ShowImageComponent } from './modules/event/show-image/show-image.component';

import { ShowVedioComponent } from './modules/event/show-vedio/show-vedio.component';

import { CMEGuard } from './core/guards/cme.guard';
import { AgendaVideoComponent } from './modules/event/agenda-video/agenda-video.component';
import { RecordedSessionsComponent } from './modules/event/recorded-sessions/recorded-sessions.component';
import { CertificateComponent } from './modules/event/certificate/certificate.component';
import { CheckoutComponent } from './modules/event/checkout/checkout.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Exhibition3dComponent } from './modules/event/exhibition3d/exhibition3d.component';
import { ExhLillyComponent } from './modules/event/exh-lilly/exh-lilly.component';
import { AuditoriumComponent } from './modules/event/auditorium/auditorium.component';
import { ExhAmgenComponent } from './modules/event/exh-amgen/exh-amgen.component';
import { ExhDepuyComponent } from './modules/event/exh-depuy/exh-depuy.component';
import { ExhMedpharmaComponent } from './modules/event/exh-medpharma/exh-medpharma.component';
import { ExhPfizerComponent } from './modules/event/exh-pfizer/exh-pfizer.component';
import { ExhSmithComponent } from './modules/event/exh-smith/exh-smith.component';
import { ExhZimmerComponent } from './modules/event/exh-zimmer/exh-zimmer.component';
import { ExhAmicoComponent } from './modules/event/exh-amico/exh-amico.component';
import { ExhStrykerComponent } from './modules/event/exh-stryker/exh-stryker.component';
import { MessageComponent } from './modules/event/message/message.component';
import { BoothComponent } from './modules/event/booth/booth.component';
import { HallsComponent } from './modules/event/halls/halls.component';
import { ShowVimeoComponent } from './modules/event/show-vimeo/show-vimeo.component';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore'
import { env } from 'process';
import { environment } from '@env/environment';
const routes: Routes = [
  // { path: '', component: Exhibition3dComponent },
  { path: '', component: LoginComponent },
  // { path: '', component: CountdownnComponent },
  // { path: '', component: EventComponent },
  // { path: '', component: UpcomingComponent },
  // { path: 'event/:slug', component: EventComponent, pathMatch: 'full' },
  { path: 'certificate', component: CertificateComponent, pathMatch: 'full' },
  { path: 'agenda', component: AgendaComponent, pathMatch: 'full' },
  { path: 'welcome', component: MessageComponent, pathMatch: 'full' },
  {
    path: 'agenda-video/:activity/:video',
    component: AgendaVideoComponent,
    pathMatch: 'full',
    canDeactivate: [CMEGuard],
  },
  {
    path: 'recorded-sessions',
    component: RecordedSessionsComponent,
    pathMatch: 'full',
  },

  { path: 'exhibition', component: ExhibitionComponent, pathMatch: 'full' },
  { path: 'booth/:slug', component: BoothComponent, pathMatch: 'full' },
  // { path: 'exhibition3d', component: Exhibition3dComponent, pathMatch: 'full' },

  // { path: 'exh-lilly', component: ExhLillyComponent, pathMatch: 'full' },
  // { path: 'exh-amgen', component: ExhAmgenComponent, pathMatch: 'full' },
  // { path: 'exh-amico', component: ExhAmicoComponent, pathMatch: 'full' },
  // { path: 'exh-depuy', component: ExhDepuyComponent, pathMatch: 'full' },
  // {
  //   path: 'exh-medpharma',
  //   component: ExhMedpharmaComponent,
  //   pathMatch: 'full',
  // },
  // { path: 'exh-pfizer', component: ExhPfizerComponent, pathMatch: 'full' },
  // {
  //   path: 'exh-smith-and-nephew',
  //   component: ExhSmithComponent,
  //   pathMatch: 'full',
  // },
  // { path: 'exh-stryker', component: ExhStrykerComponent, pathMatch: 'full' },
  // { path: 'exh-zimmer', component: ExhZimmerComponent, pathMatch: 'full' },
  {
    path: 'show-image/:image',
    component: ShowImageComponent,
    pathMatch: 'full',
  },
  {
    path: 'show-vedio/:link',
    component: ShowVedioComponent,
    pathMatch: 'full',
  },
  {
    path: 'show-vimeo/:link',
    component: ShowVimeoComponent,
    pathMatch: 'full',
  },
  { path: 'contact', component: ContactComponent, pathMatch: 'full' },
  { path: 'register', component: RegisterComponent, pathMatch: 'full' },
  {
    path: 'checkout/:user_id',
    component: CheckoutComponent,
    pathMatch: 'full',
  },
  {
    path: 'registersuccess',
    component: RegisterSuccessComponent,
    pathMatch: 'full',
  },
  { path: 'board', component: Speaker3Component, pathMatch: 'full' },
  { path: 'topics', component: TopicsComponent, pathMatch: 'full' },
  { path: 'speakers', component: Speaker4Component, pathMatch: 'full' },
  // { path: 'sponsors', component: SponsorsComponent, pathMatch: 'full' },
  { path: 'contact', component: ContactComponent, pathMatch: 'full' },
  { path: 'scientific', component: SocietyComponent, pathMatch: 'full' },
  { path: 'organizing', component: Society2Component, pathMatch: 'full' },
  { path: 'halls', component: HallsComponent, pathMatch: 'full' },

  { path: 'audi/:hall', component: AuditoriumComponent, pathMatch: 'full' },
  {
    path: 'live/:hall',
    component: LiveComponent,
    pathMatch: 'full',
    canDeactivate: [CMEGuard],
  },
  { path: 'login', component: LoginComponent, pathMatch: 'full' },
  { path: 'forget', component: ForgetPassComponent, pathMatch: 'full' },
  { path: 'about', component: AboutComponent, pathMatch: 'full' },
  { path: 'questions/:hall', component: QuestionsComponent, pathMatch: 'full' },
  // { path: 'page/:id', component: AboutComponent },
  { path: 'redirest', redirectTo: 'login' },
  { path: '**', redirectTo: 'checkin' }  ,
];

@NgModule({
  imports: [
   
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
    MatFormFieldModule,
    
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
